export const bookingFormActionTypes = {
    INITIALISE_FORM: "locale/visitors/INITIALISE_FORM",
    RESET_FORM: "locale/visitors/RESET_FORM",

    POPULATE_DATA: "locale/visitors/POPULATE_DATA",
    SUBMIT_DATA: "locale/visitors/SUBMIT_DATA",
    SET_ERRORS: "locale/visitors/SET_ERRORS",

    SET_DEFAULT_COLLAPSED_STATE: "locale/visitors/SET_DEFAULT_COLLAPSED_STATE",
    SET_FORM_MODE: "locale/visitors/SET_FORM_MODE",
    SET_BOOKING_TYPE: "locale/visitors/SET_BOOKING_TYPE",
    SET_RECURRENCE_EDIT_TYPE: "locale/visitors/SET_RECURRENCE_EDIT_TYPE",
    SET_IS_LOADING: "locale/visitors/SET_IS_LOADING",
    SET_IS_SAVING: "locale/visitors/SET_IS_SAVING",

    OPEN_EDIT_MODAL: "locale/visitors/visits/OPEN_EDIT_MODAL",
    CLOSE_EDIT_MODAL: "locale/visitors/visits/CLOSE_EDIT_MODAL",

    SET_IMPORT_MODAL_OPEN: "locale/visitors/SET_IMPORT_MODAL_OPEN",
    SET_CONFIRMATION_MODAL_OPEN: "locale/visitors/SET_CONFIRMATION_MODAL_OPEN",

    SET_WILL_PRINT_PASS_AFTER_SUBMIT: "locale/visitors/SET_WILL_PRINT_PASS_AFTER_SUBMIT",

    UPDATE_HOST: "locale/visitors/UPDATE_HOST",
    ADD_HOST: "locale/visitors/ADD_HOST",
    DELETE_HOST: "locale/visitors/DELETE_HOST",

    UPDATE_VISIT: "locale/visitors/UPDATE_VISIT",
    UPDATE_ALL_VISITS: "locale/visitors/UPDATE_ALL_VISITS",
    UPDATE_ALL_VISITS_EXCEPT_LAST: "locale/visitors/UPDATE_ALL_VISITS_EXCEPT_LAST",
    ADD_VISIT: "locale/visitors/ADD_VISIT",
    DELETE_VISIT: "locale/visitors/DELETE_VISIT",
    DELETE_ALL_VISITS_EXCEPT_FIRST: "locale/visitors/DELETE_ALL_VISITS_EXCEPT_FIRST",

    UPDATE_VISITOR: "locale/visitors/UPDATE_VISITOR",
    ADD_VISITOR: "locale/visitors/ADD_VISITOR",
    DELETE_VISITOR: "locale/visitors/DELETE_VISITOR",

    ADD_VISIT_AND_VISITOR: "locale/visitors/ADD_VISIT_AND_VISITOR",
    DELETE_VISIT_AND_VISITOR: "locale/visitors/DELETE_VISIT_AND_VISITOR",
    DELETE_EMPTY_VISITS_AND_VISITORS: "locale/visitors/DELETE_EMPTY_VISITS_AND_VISITORS",

    SET_ONBOARDING_STATUS: 'locale/visitors/visits/BOOKINGFORM_ONBOARDING_STATUS',
};
